// Central SEO + content configuration for every public page.
// One source of truth for titles, descriptions, canonical paths and unique copy.

export const RESULT_PAGES = [
  {
    slug: "/morning-sunday-teer/",
    title: "Morning Sunday Teer | Live Result",
    description:
      "Get the live Morning Sunday Teer result today with First Round (10:30 AM) and Second Round (11:30 AM) numbers, updated automatically every day.",
    variant: "morning-sunday",
    h1: "Morning Sunday Teer Live Result",
    kicker: "Live Result",
    intro:
      "Morning Sunday Teer is a popular morning archery-based number game followed across the North East. On this page you can view the latest Morning Sunday Teer result the moment it is declared, with the First Round announced around 10:30 AM and the Second Round around 11:30 AM.",
  },
  {
    slug: "/morning-sunday-teer-result/",
    title: "Morning Sunday Teer Result | Today",
    description:
      "Today's Morning Sunday Teer result with FR and SR numbers. Fast, accurate and auto-updated results plus links to previous results and common numbers.",
    variant: "morning-sunday",
    h1: "Morning Sunday Teer Result Today",
    kicker: "Today's Result",
    intro:
      "Looking for today's Morning Sunday Teer result? The result card below shows the most recent First Round and Second Round numbers for Morning Sunday Teer, refreshed automatically so you always see the latest declared outcome.",
  },
  {
    slug: "/sunday-morning-teer/",
    title: "Sunday Morning Teer | Live Result",
    description:
      "Sunday Morning Teer live result with First Round (10:30 AM) and Second Round (11:30 AM) numbers. Bookmark this page for daily Sunday Morning Teer updates.",
    variant: "sunday-morning",
    h1: "Sunday Morning Teer Live Result",
    kicker: "Live Result",
    intro:
      "Sunday Morning Teer brings the same fast morning-round format that enthusiasts follow every day. This page displays the live Sunday Morning Teer result as soon as each round is declared, along with quick access to older charts.",
  },
  {
    slug: "/sunday-morning-teer-result/",
    title: "Sunday Morning Teer Result | Today",
    description:
      "Check today's Sunday Morning Teer result with accurate FR and SR numbers. Auto-updated result card with previous results and common number links.",
    variant: "sunday-morning",
    h1: "Sunday Morning Teer Result Today",
    kicker: "Today's Result",
    intro:
      "Here is today's Sunday Morning Teer result. The card below is powered by our central result data layer, so the numbers you see match the latest declared First and Second Round outcomes without any manual entry.",
  },
  {
    slug: "/shillong-morning-teer/",
    title: "Shillong Morning Teer | Live Result",
    description:
      "Shillong Morning Teer live result today with First Round and Second Round numbers, updated automatically. View charts, previous results and common numbers.",
    variant: "shillong-morning",
    h1: "Shillong Morning Teer Live Result",
    kicker: "Live Result",
    intro:
      "Shillong Morning Teer is followed closely for its early morning rounds. This page shows the live Shillong Morning Teer result and keeps a running history so you can compare today's numbers with earlier days.",
  },
  {
    slug: "/shillong-morning-teer-result/",
    title: "Shillong Morning Teer Result | Today",
    description:
      "Today's Shillong Morning Teer result with FR (10:30 AM) and SR (11:30 AM) numbers. Fast, reliable and automatically refreshed for every visitor.",
    variant: "shillong-morning",
    h1: "Shillong Morning Teer Result Today",
    kicker: "Today's Result",
    intro:
      "Find today's Shillong Morning Teer result below. Both the First Round and Second Round numbers are pulled from the same trusted data source used across every result page on this site.",
  },
];

export const PREVIOUS_PAGES = [
  {
    slug: "/morning-teer-previous-result/",
    title: "Morning Teer Previous Result",
    description:
      "Browse the complete Morning Teer previous result chart with dates, city, F/R and S/R numbers. Responsive table with pagination for older results.",
    variant: "morning-sunday",
    h1: "Morning Teer Previous Result Chart",
    kicker: "Previous Results",
    intro:
      "This archive lists Morning Teer previous results in a clean, mobile-friendly table. Use it to study historical First Round and Second Round outcomes and to compare patterns across recent days.",
  },
  {
    slug: "/morning-sunday-teer-previous-result/",
    title: "Morning Sunday Teer Previous Result",
    description:
      "Morning Sunday Teer previous result history with date, city, F/R and S/R. Paginated archive of older Morning Sunday Teer results for easy reference.",
    variant: "morning-sunday",
    h1: "Morning Sunday Teer Previous Result",
    kicker: "Previous Results",
    intro:
      "Every declared Morning Sunday Teer result is automatically saved here. When a new day's result is published, the earlier result moves into this archive so the record stays complete without any manual updates.",
  },
  {
    slug: "/shillong-morning-teer-previous-result/",
    title: "Shillong Morning Teer Previous Result",
    description:
      "Shillong Morning Teer previous result table with dates, city, F/R and S/R numbers. Fully responsive, paginated history for older results.",
    variant: "shillong-morning",
    h1: "Shillong Morning Teer Previous Result",
    kicker: "Previous Results",
    intro:
      "Review the Shillong Morning Teer previous result history below. The table is optimised for phones and includes pagination so you can scroll back through many days of results.",
  },
  {
    slug: "/sunday-morning-teer-previous-result/",
    title: "Sunday Morning Teer Previous Result",
    description:
      "Sunday Morning Teer previous result archive with date, city, F/R and S/R. Browse older Sunday Morning Teer results in a responsive paginated table.",
    variant: "sunday-morning",
    h1: "Sunday Morning Teer Previous Result",
    kicker: "Previous Results",
    intro:
      "Here is the Sunday Morning Teer previous result archive. All historical First Round and Second Round numbers are stored in one place and kept up to date automatically.",
  },
];

export const COMMON_PAGES = [
  {
    slug: "/morning-sunday-teer-common-number/",
    title: "Morning Sunday Teer Common Number",
    description:
      "Morning Sunday Teer common number today with direct, house and ending numbers. Deterministic daily common numbers that stay stable all day.",
    variant: "morning-sunday",
    h1: "Morning Sunday Teer Common Number",
    kicker: "Common Number",
    intro:
      "The Morning Sunday Teer common number is generated for each day and stays the same no matter how many times you refresh. It rolls over to the next day automatically after 8:00 PM (IST).",
  },
  {
    slug: "/shillong-morning-teer-common-number/",
    title: "Shillong Morning Teer Common Number",
    description:
      "Shillong Morning Teer common number today with direct, house and ending numbers. Stable daily values with an automatic 8 PM IST schedule.",
    variant: "shillong-morning",
    h1: "Shillong Morning Teer Common Number",
    kicker: "Common Number",
    intro:
      "View the Shillong Morning Teer common number for today, including house and ending numbers. These numbers are for informational and entertainment reference only.",
  },
  {
    slug: "/sunday-morning-teer-common-number/",
    title: "Sunday Morning Teer Common Number",
    description:
      "Sunday Morning Teer common number today with direct, house and ending numbers. Consistent daily values that do not change on refresh.",
    variant: "sunday-morning",
    h1: "Sunday Morning Teer Common Number",
    kicker: "Common Number",
    intro:
      "The Sunday Morning Teer common number below is calculated using a fixed date-based method, so the same day always shows the same value. Numbers update on the next day's schedule after 8:00 PM IST.",
  },
  {
    slug: "/morning-teer-common-number/",
    title: "Morning Teer Common Number",
    description:
      "Morning Teer common number today with direct, house and ending numbers. Deterministic daily common numbers, stable across refreshes.",
    variant: "morning-sunday",
    h1: "Morning Teer Common Number",
    kicker: "Common Number",
    intro:
      "This page shows the Morning Teer common number for the current day. All common numbers on this site are informational references derived from a consistent date-based method.",
  },
];

export const ALL_SEO_PAGES = [...RESULT_PAGES, ...PREVIOUS_PAGES, ...COMMON_PAGES];

export const LEGAL_PAGES = [
  { slug: "/about/", title: "About Us | Morning Sunday Teer" },
  { slug: "/contact/", title: "Contact Us | Morning Sunday Teer" },
  { slug: "/privacy-policy/", title: "Privacy Policy | Morning Sunday Teer" },
  { slug: "/terms-and-conditions/", title: "Terms & Conditions | Morning Sunday Teer" },
  { slug: "/disclaimer/", title: "Disclaimer | Morning Sunday Teer" },
];

// Related-link helpers for strong internal linking.
export function relatedFor(variant) {
  const result = RESULT_PAGES.find((p) => p.variant === variant) || RESULT_PAGES[0];
  const previous = PREVIOUS_PAGES.find((p) => p.variant === variant) || PREVIOUS_PAGES[0];
  const common = COMMON_PAGES.find((p) => p.variant === variant) || COMMON_PAGES[0];
  return { result, previous, common };
}
